import React from 'react'
import PropTypes from 'prop-types'

// material ui
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormLabel from '@mui/material/FormLabel'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'
import Typography from '@mui/material/Typography'

// components
import FormTextFieldWithValidation from 'components/shared/FormTextFieldWithValidation'
import FormControlWithErrorHelper from 'components/shared/FormControlWithErrorHelper'

const WaiverFormFields = props => {
  const {
    accept, // via withQuery
    reject, // via withQuery
    onChangeConsent, // via withEventHandlers
    onChangeFormField, // via withEventHandlers
    waiverForm, // via redux state (null before it's set via useEffect)
    formErrors
  } = props

  if (!waiverForm) {
    return null
  }

  const { consent } = waiverForm

  return (
    <>
      <form>
        <FormControlWithErrorHelper
          component='fieldset'
          errorsObject={formErrors}
          errorField='consent'
          required
        >
          <FormLabel required={false} htmlFor='consent' component='legend'>
            Please select an option
          </FormLabel>
          <RadioGroup
            id='consent'
            value={String(consent)}
            onChange={onChangeConsent}
            aria-label='consent'
            name='consent'
          >
            <FormControlLabel
              value='true'
              control={<Radio />}
              label={
                <Box my={[1, 2]}>
                  <Typography component='span' sx={{ fontWeight: 'bold' }}>
                    {accept}
                  </Typography>
                </Box>
              }
            />
            <FormControlLabel
              value='false'
              control={<Radio />}
              label={
                <Box my={[1, 2]}>
                  <Typography component='span' sx={{ fontWeight: 'bold' }}>
                    {reject}
                  </Typography>
                </Box>
              }
            />
          </RadioGroup>
        </FormControlWithErrorHelper>
        <FormTextFieldWithValidation
          label='Type your Full Name to Confirm Acceptance'
          field='acceptedBy'
          form={waiverForm}
          onChange={onChangeFormField}
          errors={formErrors}
          required
        />
      </form>
    </>
  )
}

WaiverFormFields.propTypes = {
  title: PropTypes.string.isRequired,
  waiverForm: PropTypes.object,
  formErrors: PropTypes.object.isRequired
}

export default WaiverFormFields
